import { get } from 'lodash-es';
import { useSearchParams } from 'react-router';

import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';

import { AccountMembers } from './account-members/account-members';
import { AccountPlan } from './account-plan/account-plan';
import { Tabs } from './account-settings.page-style';
import { AccountSettingsTabEnum } from './account-settings.tab-enum';

export const AccountSettingsPage = () => {
  const { current, accounts } = useCurrentApplication();
  const [params, setParam] = useSearchParams();

  return (
    <PageWrapper>
      {accounts.length > 1 ? (
        <PageTitle>Account settings of &ldquo;{get(current, ['account', 'name'])}&rdquo; team</PageTitle>
      ) : (
        <PageTitle>Account settings</PageTitle>
      )}
      <Tabs
        defaultActiveKey={params.get('tab') ?? AccountSettingsTabEnum.Team}
        items={[
          {
            key: AccountSettingsTabEnum.Team,
            label: `Members`,
            children: <AccountMembers />,
          },
          {
            key: AccountSettingsTabEnum.Plan,
            label: `Plan & Billing`,
            children: <AccountPlan />,
          },
        ]}
        onChange={(tab) => setParam({ tab })}
      />
    </PageWrapper>
  );
};
